import * as React from 'react';
import Swiper from 'react-id-swiper';
import { Link } from 'react-router-dom';
import config from '../../config/config';
import shareConfig from '../../config/share.config';
import server from '../../server/apiServer';
import HeaderComp from '../../components/common/header';
import LoadingMoreComp from '../../components/common/loading-more';
import FooterComp from '../../components/common/footer';
import ToTopComp from '../../components/common/toTop';
import ItemComp from '../../components/main/item';

interface IProps extends React.Props<any> {
    match: any
}

const swiperParams = {
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  }


class MainComp extends React.Component<IProps, any> {
    public state = {
        banner: [], // 轮播图
        listExclude: '', // 列表排除id，用于排除轮播图
        list1: [], // 列表数据
        list2: [], // 列表数据
        list3: [], // 列表数据
        page: 3, // 页面
        adList: [ '', ''], // 广告
        isLoading: false, // 是否加载中...
        loadedOver: false, // 是否加载完成
    };
    private contentWidth = window.innerWidth > 640 ? 640 : window.innerWidth;
    public componentDidMount() {
        (window as any)._hmt.push(['_trackPageview', '/']);
        window.scrollTo(0, 0);
        // 加载轮播图
        this.getBanner();
        // 记载广告
        this.getAd();

        // 获取分享信息，设置分享内容
        const xhrData = `jsApiDomain=&url=${encodeURIComponent(window.location.href.split('#')[0])}`;
        (window as any).WeChatShare({
            callback() {
                const shareInfo = shareConfig.main;
                const [title, desc, imgUrl, link] = [
                    shareInfo.title,
                    shareInfo.desc,
                    shareInfo.imgUrl,
                    shareInfo.link()
                ];
                (window as any).wx.onMenuShareAppMessage({
                    desc,
                    imgUrl,
                    link,
                    title
                });
                (window as any).wx.onMenuShareTimeline({
                  desc,
                  imgUrl,
                  link,
                  title
                });
            },
            data: xhrData,
            url: config.WAPAPI
        });
    };
    public render() {
        const state = this.state;
        return (
            <div>
                <HeaderComp parentProps={this.props}/>
                <div className="list-container">
                    <Swiper {...swiperParams} rebuildOnUpdate={true} loop={true}>
                        {
                            state.banner.map((v: any, k: number) => {
                                return (
                                    <div className="banner-item" key={`bannerItem${v.id}`}>
                                        <Link to={`/news/${v.id}`}>
                                            <img src={v.picUrl} style={{width: `${this.contentWidth}px`, height: `${this.contentWidth / 2.27}px`}}/>
                                            <p>{v.articleName}</p>
                                        </Link> 
                                    </div>
                                )
                            })
                        }
                    </Swiper>
                    <ul className="main-list">
                        {
                            state.list1.map((v: any, k: number) => {
                                return (
                                    <ItemComp key={`main-item${k}`} data={v} />
                                );
                            })
                        }
                    </ul>
                    <div className="main-special" dangerouslySetInnerHTML={{ __html: state.adList[0]}} />
                    <ul className="main-list">
                        {
                            state.list2.map((v: any, k: number) => {
                                return (
                                    <ItemComp key={`main-item${k}`} data={v} />
                                );
                            })
                        }
                    </ul>
                    <div className="main-special" dangerouslySetInnerHTML={{ __html: state.adList[1]}} />
                    <ul className="main-list">
                        {
                            state.list3.map((v: any, k: number) => {
                                return (
                                    <ItemComp key={`main-item${k}`} data={v} />
                                );
                            })
                        }
                    </ul>
                </div>
                {
                    !state.loadedOver ? <LoadingMoreComp isLoading={state.isLoading} loadMoreAction={() => this.loadMoreActoin()}/> : null
                }
                <FooterComp />
                <ToTopComp hideHome={true}/>
            </div>
        );
    }
    // 加载轮播图
    private async getBanner() {
        const r = await server.get('wap/index/banner');
        if(r.code === 1) {
            this.setState({
                banner: r.obj.bannerList,
                listExclude: r.obj.ids
            });
            this.getList(1);
            this.getList(2);
            this.getList();
        }
    }
    // 加载列表数据
    private async getList(page?: number) {
        const r = await server.get('wap/index/list', {
            ids: this.state.listExclude,
            pageSize: 5,
            pageNum: typeof page === 'undefined' ? this.state.page : page
        });
        if(r.code === 1) {
            if(typeof page === 'undefined') {
                this.setState({
                    list3: [...this.state.list3, ...r.obj.list]
                });
            } else {
                if(page === 1) {
                    this.setState({
                        list1: r.obj.list
                    });
                } else if(page === 2) {
                    this.setState({
                        list2: r.obj.list
                    });
                }
            }
        }
        this.setState({
            isLoading: false,
            loadedOver: r.obj.pages <= this.state.page ? true : false
        });
    }
    private async getAd() {
        const r = await server.get('api/specialcontent/get', {
            code: '0050080915'
        }, config.PCAPI);
        if(r.code === 0) {
            this.setState({
                adList: [ r.data.formalContent ]
            });
        } else {
            this.setState({
                adList: ['']
            });
        }
        const r2 = await server.get('api/specialcontent/get', {
            code: '0050080916'
        }, config.PCAPI);
        if(r2.code === 0) {
            this.setState({
                adList: [...this.state.adList, r2.data.formalContent]
            });
        } else {
            this.setState({
                adList: [...this.state.adList, '']
            });
        }
    }
    // 加载更多数据
    private loadMoreActoin() {
        if(this.state.isLoading) {
            return;
        }
        this.setState({isLoading: true});
        this.state.page ++;
        this.getList();
    }
}

export default MainComp;


// WEBPACK FOOTER //
// ./src/containers/main/index.tsx